import { Component } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { ColorPickerComponent } from '@progress/kendo-angular-inputs';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-customcolor',
  standalone: true,
  imports: [
    ColorPickerComponent
  ],
  templateUrl: './grid-cell-customcolor.component.html',
  styleUrl: './grid-cell-customcolor.component.scss'
})
export class GridCellCustomcolorComponent extends GridCellBaseComponent<string> {

  public propertyValue: string;
  public propertyText: string;
  public isCustom: boolean = false;

  //If the column doesn't have have display styles we can reduce the padding (for id columns for example)
  public columnHasDisplayStyle = false;

  protected override onDataChanged(): void {
    this.propertyText = '';
    this.propertyValue = '';
    this.isCustom = false;
    const idProperty = this.column.field;
    const id = this.data[idProperty];
    this.propertyValue = id;
    if (id != undefined) {
      this.propertyText = this.column.Enum?.find(_ => _.Value == id)?.Text ?? 'Custom';
      this.isCustom = this.propertyText == 'Custom';
    }
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public onValueChange($event: string): void {
    this.onCellAction.emit({
      data: {
        data: {
          data: this.data,
          column: this.column,
          value: $event
        }
      },
      action: CellActionType.CUSTOM_COLOR_CHANGE,
      mouseEvent: undefined
    });
  }
}
